export const getFileName = (file) => {
  return file?.name || "No file name";
};
